module.exports = "/_next/static/resources/photo-1-2ebe88bcd8cc952fcb3e31e0feeb0357.webp";